/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState } from "react";
import "./styles.css";
import NavbarSection from "./sections/NavbarSection";
import ContainerSection from "./sections/ContainerSection";
import ContainerSection2 from "./sections/ContainerSection2";
import ContainerSection3 from "./sections/ContainerSection3";
import ContainerSection4 from "./sections/ContainerSection4";
import ContainerSection5 from "./sections/ContainerSection5";
import FilterableFeaturesSection from "./sections/FilterableFeaturesSection";
import ImageSection from "./sections/ImageSection";
import ContainerSection6 from "./sections/ContainerSection6";
import FooterSection from "./sections/FooterSection";

export interface MyIshealthCloudLandingProps {
  lang?: "th" | "en";
  onNavigate?: (path: string) => void;
  onLangChange?: (lang: string) => void;
}

const MyIshealthCloudLanding: React.FC<MyIshealthCloudLandingProps> = ({ lang = "th", onNavigate, onLangChange }) => {
  const [currentLang, setCurrentLang] = useState<"th" | "en">(lang);

  const handleLangChange = (newLang: string) => {
    setCurrentLang(newLang.toLowerCase() as "th" | "en");
    onLangChange?.(newLang);
  };

  return (
    <div className="my-ishealth-cloud-landing-page">
      <NavbarSection onNavigate={onNavigate} onLangChange={handleLangChange} lang={currentLang} />
      <ContainerSection onNavigate={onNavigate} lang={currentLang} />
      <ContainerSection2 lang={currentLang} />
      <ContainerSection3 lang={currentLang} />
      <ContainerSection4 onNavigate={onNavigate} lang={currentLang} />
      <ContainerSection5 lang={currentLang} />
      <FilterableFeaturesSection lang={currentLang} />
      <ImageSection lang={currentLang} />
      <ContainerSection6 lang={currentLang} />
      <FooterSection lang={currentLang} />
    </div>
  );
};

export default MyIshealthCloudLanding;
